
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_256","data-name":"Group 256"}},[_c('g',{attrs:{"id":"Group_254","data-name":"Group 254"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_106","data-name":"Path 106","d":"M999.17 500.51c0 275.68-223.57 499.13-499.26 499.09S.78 776 .83 500.34a499.17 499.17 0 01363.86-480.4l32.25 114.74C195 191.6 77.36 401.49 134.28 603.47s266.8 319.58 468.79 262.66 319.58-266.8 262.66-468.79a380.76 380.76 0 00-18.6-51.47L956 297.35a499.48 499.48 0 0143.17 203.16z"}})]),_c('g',{attrs:{"id":"Group_255","data-name":"Group 255"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_107","data-name":"Path 107","d":"M891.09 162.4L500 553.49V.41A551.23 551.23 0 01891.09 162.4z"}})])])])
          )
        }
      }
    